import { render, staticRenderFns } from "./xsbadnessReportList.vue?vue&type=template&id=7d6c0ee4&scoped=true"
import script from "./xsbadnessReportList.vue?vue&type=script&lang=js"
export * from "./xsbadnessReportList.vue?vue&type=script&lang=js"
import style0 from "./xsbadnessReportList.vue?vue&type=style&index=0&id=7d6c0ee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6c0ee4",
  null
  
)

export default component.exports